<template>
  <div>
    <div class="card banner standard-card">
      <h4>Pobierz banery AC/OC</h4>
      <p>Skopiuj kod banera i wklej na swoją stronę.</p>
      <button class="btn btn--full-width btn--cta-red" @click="isAc = !isAc" :class="{active: isAc}"><span v-if="!isAc">Pokaż banery</span><span v-else>Ukryj banery</span></button>
      <div class="banner-row" v-if="isAc">
        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                   v-bind:url="`https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac`"
                   v-bind:size="`300x125px v1`" v-bind:utm_campaign="`auto`" v-bind:utm_source="`partnerski`" v-bind:utm_medium="`${getMpcCode}`"
                   v-bind:utm_brand="`punkta`"
                   v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_300x125_v1.jpg`"/>
        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                   v-bind:url="`https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac`"
                   v-bind:size="`300x125px v2`" v-bind:utm_campaign="`auto`" v-bind:utm_source="`partnerski`"
                   v-bind:utm_medium="`${getMpcCode}`" v-bind:utm_brand="`punkta`"
                   v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_300x125_v2.jpg`"/>
        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                   v-bind:url="`https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac`"
                   v-bind:size="`300x125px v3`" v-bind:utm_campaign="`auto`" v-bind:utm_source="`partnerski`"
                   v-bind:utm_medium="`${getMpcCode}`" v-bind:utm_brand="`punkta`"
                   v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_300x125_v3.jpg`"/>

        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                   v-bind:url="`https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac`"
                   v-bind:size="`300x250px`" v-bind:utm_campaign="`auto`" v-bind:utm_source="`partnerski`"
                   v-bind:utm_medium="`${getMpcCode}`" v-bind:utm_brand="`punkta`"
                   v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_300x250.jpg`"/>

        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                   v-bind:url="`https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac`"
                   v-bind:size="`468x60px`" v-bind:utm_campaign="`auto`" v-bind:utm_source="`partnerski`"
                   v-bind:utm_medium="`${getMpcCode}`" v-bind:utm_brand="`punkta`"
                   v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_468x60.jpg`"/>

        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                   v-bind:url="`https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac`"
                   v-bind:size="`540x30px_v1`" v-bind:utm_campaign="`auto`" v-bind:utm_source="`partnerski`"
                   v-bind:utm_medium="`${getMpcCode}`" v-bind:utm_brand="`punkta`"
                   v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_540x30_v1.jpg`"/>

        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                   v-bind:url="`https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac`"
                   v-bind:size="`540x30px_v2`" v-bind:utm_campaign="`auto`" v-bind:utm_source="`partnerski`"
                   v-bind:utm_medium="`${getMpcCode}`" v-bind:utm_brand="`punkta`"
                   v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_540x30_v2.jpg`"/>

        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                   v-bind:url="`https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac`"
                   v-bind:size="`540x30px_v3`" v-bind:utm_campaign="`auto`" v-bind:utm_source="`partnerski`"
                   v-bind:utm_medium="`${getMpcCode}`" v-bind:utm_brand="`punkta`"
                   v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_540x30_v3.jpg`"/>

        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                   v-bind:url="`https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac`"
                   v-bind:size="`728x90px`" v-bind:utm_campaign="`auto`" v-bind:utm_source="`partnerski`"
                   v-bind:utm_medium="`${getMpcCode}`" v-bind:utm_brand="`punkta`"
                   v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_728x90.jpg`"/>

        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                   v-bind:url="`https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac`"
                   v-bind:size="`750x200px`" v-bind:utm_campaign="`auto`" v-bind:utm_source="`partnerski`"
                   v-bind:utm_medium="`${getMpcCode}`" v-bind:utm_brand="`punkta`"
                   v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_750x200.jpg`"/>

        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                   v-bind:url="`https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac`"
                   v-bind:size="`160x600px`" v-bind:utm_campaign="`auto`" v-bind:utm_source="`partnerski`" v-bind:utm_medium="`${getMpcCode}`"
                   v-bind:utm_brand="`punkta`"
                   v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_160x600.jpg`"/>

        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                   v-bind:url="`https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac`"
                   v-bind:size="`300x600px_v1`" v-bind:utm_campaign="`auto`" v-bind:utm_source="`partnerski`"
                   v-bind:utm_medium="`${getMpcCode}`" v-bind:utm_brand="`punkta`"
                   v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_300x600.jpg`"/>

        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                   v-bind:url="`https://punkta.pl/ubezpieczenie-oc-ac/kalkulator-oc-ac`"
                   v-bind:size="`300x600px_v2`" v-bind:utm_campaign="`auto`" v-bind:utm_source="`partnerski`"
                   v-bind:utm_medium="`${getMpcCode}`" v-bind:utm_brand="`punkta`"
                   v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/ocac/punkta_ocac_300x600-1.jpg`"/>

      </div>
    </div>

    <div class="card banner standard-card">
      <h4>Pobierz banery Travel</h4>
      <p>Skopiuj kod banera i wklej na swoją stronę.</p>
      <button class="btn btn--full-width btn--cta-red" @click="isTravel = !isTravel" :class="{active: isTravel}"><span v-if="!isTravel">Pokaż banery</span><span v-else>Ukryj banery</span></button>
      <div class="banner-row" v-if="isTravel">
        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                   v-bind:url="`https://punkta.pl/ubezpieczenie-turystyczne/kalkulator`"
                   v-bind:size="`160x600px_v1`" v-bind:utm_source="`partnerski`" v-bind:utm_campaign="`travel`" v-bind:utm_medium="`${getMpcCode}`"
                   v-bind:utm_brand="`punkta`"
                   v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/podroz/t160x600_w1.jpg`"/>
        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                   v-bind:url="`https://punkta.pl/ubezpieczenie-turystyczne/kalkulator`"
                   v-bind:size="`160x600px_v2`" v-bind:utm_source="`partnerski`" v-bind:utm_campaign="`travel`" v-bind:utm_medium="`${getMpcCode}`"
                   v-bind:utm_brand="`punkta`"
                   v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/podroz/t160x600_w2.jpg`"/>
        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                   v-bind:url="`https://punkta.pl/ubezpieczenie-turystyczne/kalkulator`"
                   v-bind:size="`160x600px_v3`" v-bind:utm_source="`partnerski`" v-bind:utm_campaign="`travel`" v-bind:utm_medium="`${getMpcCode}`"
                   v-bind:utm_brand="`punkta`"
                   v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/podroz/t160x600_w3.jpg`"/>
        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                   v-bind:url="`https://punkta.pl/ubezpieczenie-turystyczne/kalkulator`"
                   v-bind:size="`300x250px_v1`" v-bind:utm_source="`partnerski`" v-bind:utm_campaign="`travel`" v-bind:utm_medium="`${getMpcCode}`"
                   v-bind:utm_brand="`punkta`"
                   v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/podroz/t300X250_w1.jpg`"/>
        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                   v-bind:url="`https://punkta.pl/ubezpieczenie-turystyczne/kalkulator`"
                   v-bind:size="`300x250px_v2`" v-bind:utm_source="`partnerski`" v-bind:utm_campaign="`travel`" v-bind:utm_medium="`${getMpcCode}`"
                   v-bind:utm_brand="`punkta`"
                   v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/podroz/t300X250_w2.jpg`"/>
        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                   v-bind:url="`https://punkta.pl/ubezpieczenie-turystyczne/kalkulator`"
                   v-bind:size="`300x250px_v3`" v-bind:utm_source="`partnerski`" v-bind:utm_campaign="`travel`" v-bind:utm_medium="`${getMpcCode}`"
                   v-bind:utm_brand="`punkta`"
                   v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/podroz/t300X250_w3.jpg`"/>
        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                    v-bind:url="`https://punkta.pl/ubezpieczenie-turystyczne/kalkulator`"
                    v-bind:size="`750x100px_v1`" v-bind:utm_source="`partnerski`" v-bind:utm_campaign="`travel`" v-bind:utm_medium="`${getMpcCode}`"
                    v-bind:utm_brand="`punkta`"
                    v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/podroz/t750x100_w1.jpg`"/>
        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                    v-bind:url="`https://punkta.pl/ubezpieczenie-turystyczne/kalkulator`"
                    v-bind:size="`750x100px_v2`" v-bind:utm_source="`partnerski`" v-bind:utm_campaign="`travel`" v-bind:utm_medium="`${getMpcCode}`"
                    v-bind:utm_brand="`punkta`"
                    v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/podroz/t750x100_w2.jpg`"/>
        <banner-url type="text" name="baner_url" label="Baner do skopiowania"
                    v-bind:url="`https://punkta.pl/ubezpieczenie-turystyczne/kalkulator`"
                    v-bind:size="`750x100px_v3`" v-bind:utm_source="`partnerski`" v-bind:utm_campaign="`travel`" v-bind:utm_medium="`${getMpcCode}`"
                    v-bind:utm_brand="`punkta`"
                    v-bind:imageUrl="`https://files-punkta.s3.amazonaws.com/internal/podroz/t750x100_w3.jpg`"/>
      </div>

    </div>
    <div class="card standard-card">
      <h4>Porównywarka ubezpieczeń na Twojej stronie internetowej</h4>
      <p>White Label to porównywarka ubezpieczeń komunikacyjnych pod Twoją marką. Jeśli posiadasz stronę www i chcesz wzbogacić ją o porównywarkę - napisz <a href="mailto:partnerzy@punkta.pl">partnerzy@punkta.pl</a>. Modele rozliczenia do uzgodnienia: Revenue Share, CPO, CPS.</p>
    </div>
  </div>
</template>

<script>
import {userHasRole, userHasAnyOfRoles} from '@/services/helper'
import BannerUrl from '@/components/banners/bannerUrl'
import {mapGetters} from 'vuex'

export default {
  components: {BannerUrl},
  computed: {
    ...mapGetters(['getUserRoles', 'getMpcCode']),
    isAgent () {
      return userHasRole(this.getUserRoles, 'agent')
    },
    isAnyAgent () {
      const agentRoles = ['agent', 'agent_level2']
      return userHasAnyOfRoles(this.getUserRoles, agentRoles)
    }
  },
  data () {
    return {
      isAc: false,
      isTravel: false
    }
  }
}
</script>
<style lang="scss" src="./banners.scss"></style>



// WEBPACK FOOTER //
// banners.vue?47ce626b